import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { FinishCode } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class FinishCodeService extends TmsWebBaseEditService<FinishCode, FinishCode> {
  // Fired after the Details form saves: the weaving screens stay open on save and the
  // host re-reads its model so the whole screen refreshes in place (R5, Steve 2026-09-09).
  public refreshDetails = new Subject<void>();

  constructor() {
    super('FinishCode', $localize`Finish Code`);
  }
}
